/** @format */

export function getHmID() {
  return this.id;
}

export function getHmUrl() {
  return "https://human.made.live/id/h/" + this.id;
}
